import { registerNotification } from './registry'

registerNotification('location:enter', {
  color: (_, theme) => theme.semantic.secondary,
  icon:  () => 'login',
})